import type { ClassValue } from "svelte/elements";

export enum ButtonVariant {
	Primary = "Primary",
	Secondary = "Secondary",
	Filled = "Filled",
	InCart = "InCart",
	NoDesign = "NoDesign",
}

export function getButtonClass(variant: ButtonVariant): ClassValue {
	switch (variant) {
		case ButtonVariant.NoDesign:
			return "";
		case ButtonVariant.Filled:
			return "flex justify-center items-center text-center px-4 py-2.5 text-xs/2.5 font-bold text-white border-0 bg-nov-red-300 rounded-full tracking-wider";
		case ButtonVariant.InCart:
			return "flex justify-center items-center text-center px-4 py-2.5 text-xs/2.5 font-bold text-nov-dark-900 border-0 bg-nov-green-100 rounded-full tracking-wider";
		case ButtonVariant.Secondary:
			return "flex justify-center hover:bg-nov-red-300 hover:text-white transition-colors duration-300 items-center text-center px-5 py-2.5 text-xs/4 font-bold text-nov-red-300 border-2 border-nov-red-300 rounded-full uppercase tracking-wider";
		case ButtonVariant.Primary:
			return "flex justify-center hover:border-nov-red-300 transition-colors duration-300 items-center text-center px-6 py-5 font text-white font-bold text-3.5/3.5 xs:text-md/4 bg-nov-red-300 rounded-full border-[#CC000E] border-4 border-b border-[0.25rem] uppercase tracking-wider";
	}
}
